
import {Component} from 'vue-property-decorator';
import {deleteImportedSession, fetchImportedSessions} from '@/repositories/api/ImportedSessionApi';
import BaseListView from '@/views/BaseListView.vue';
import Session from '@/models/Session';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';
import Overlay from '@/models/Overlay';

@Component
export default class SessionImportedView extends BaseListView {
  title = 'Importées';
  fetchItems: Function = fetchImportedSessions;
  newItemLabel = 'Nouvel import';
  headers = [
    {
      text: 'ID',
      align: 'left',
      sortable: true,
      value: 'id',
    },
    {text: 'Nom', value: 'name'},
    {text: 'Affaire', value: 'affair.affairName'},
    {text: 'Observateur', value: 'watcher.fullName'},
    {text: 'Date', value: 'date'},
    {text: 'Actions', value: 'action', sortable: false, align: 'right'},
  ];
  protected viewLabel = 'Importées';
  protected deleteDialog = false;
  protected selectedDeleteDialog = false;
  protected overlay = new Overlay();
  protected items: Session[] = [];
  protected deleteIndex: number = -1;
  protected alert = new Alert();
  protected selected: Session[] = [];

  newItemAction(){
    this.$router.push({name: 'session_import'})
  }

  async deleteSession(session: Session) {
    this.overlay.text = 'Suppression de la (des) session(s) en cours...';
    this.overlay.show = true;

    try {
      const response: { status: string, message: string } = await deleteImportedSession(session.id as number);

      if(response.status == 'success'){
        this.items.splice(this.items.indexOf(session), 1)
      }

      this.alert = new Alert(response.message, response.status, true);
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    this.overlay.show = false;
  }

  async processDeleteItem() {
    this.deleteDialog = false;
    await this.deleteSession(this.items[this.deleteIndex]);
  }

  async processSelectedDeleteItem() {
    this.selectedDeleteDialog = false;
    this.selected.forEach(session => this.deleteSession(session));
    this.selected = [];
  }
}
